import { pluralize } from '@travelata-libs/utils';
import type { Product } from '@/entities/product';
import { HOTELS_MAP_TEXTS, REVIEWS_PLURAL_FORMS } from '../config/texts';

export interface HotelCardReviews {
  rating: number | null;
  countLabel: string;
}

const WHITESPACE_RE = /\s/g;
const NBSP = ' ';
const RU_NUMBER_FORMAT = new Intl.NumberFormat('ru-RU');

function isFilledString(value: unknown): value is string {
  return typeof value === 'string' && value.trim() !== '';
}

function formatCount(count: number): string {
  return RU_NUMBER_FORMAT.format(count).replaceAll(WHITESPACE_RE, NBSP);
}

export function getHotelCardPhotos(product: Product): string[] {
  const photos = (product.hotel?.photos ?? []).filter((photo) => isFilledString(photo));
  const cover = product.hotel?.cover;

  if (photos.length) return photos;

  return isFilledString(cover) ? [cover] : [];
}

export function getHotelCardLocation(product: Product): string {
  return [product.country?.name, product.resort?.name].filter(Boolean).join(HOTELS_MAP_TEXTS.locationJoin);
}

export function getHotelCardReviews(product: Product): HotelCardReviews {
  const rating = product.hotel?.rating ?? null;
  const reviewsNumber = product.hotel?.reviewsNumber ?? 0;

  if (rating === null || !Number.isFinite(reviewsNumber) || reviewsNumber <= 0) {
    return { rating: null, countLabel: HOTELS_MAP_TEXTS.reviewsEmpty };
  }

  return {
    rating,
    countLabel: `${formatCount(reviewsNumber)} ${pluralize(REVIEWS_PLURAL_FORMS, reviewsNumber, false)}`,
  };
}
